import React from 'react';
import styled from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Proficiency from './components/Proficiency';
import EHRPlatforms from './components/EHRPlatforms';
import SoftwarePlatforms from './components/SoftwarePlatforms';
import Certificates from './components/Certificates';

const Footer = styled.footer`
  background-color: var(--dark-blue);
  color: var(--white);
  padding: 2rem 0;
  text-align: center;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const Copyright = styled.p`
  font-size: 0.9rem;
  opacity: 0.8;
`;

function App() {
  return (
    <>
      <GlobalStyles />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Proficiency />
        <Skills />
        <EHRPlatforms />
        <SoftwarePlatforms />
        <Certificates />
        <Experience />
        <Testimonials />
        <Contact />
      </main>
      <Footer>
        <FooterContent>
          <Copyright>&copy; {new Date().getFullYear()} Karen Lorca. All rights reserved.</Copyright>
        </FooterContent>
      </Footer>
    </>
  );
}

export default App;
